import { append, includes, without } from 'ramda';
import { StatsInterval } from 'src/js/model/api/request/stream-stat-request';

/**
 * Make any inactive lines invisible by adjusting the color scale.
 * It will set the colors to `none` for the inactive fields.
 * @param fields: all the chart fields
 * @param inactiveFields: all the inactive chart fields
 * @param colors: the colors
 */
export const adjustInactiveColors = (fields: string[], inactiveFields: string[], colors: string[]) => {
  return fields
    .map((field, index) => (includes(field, inactiveFields) ? 'none' : colors[index % colors.length]))
    .filter((color) => color !== 'none');
};

// return array with item added or removed depending on presence in inactiveItems
export const toggleItem = (item: string, list: string[]): string[] => {
  return includes(item, list) ? without([item], list) : append(item, list);
};

export const getItemLengthByTimescale = (ts: StatsInterval) => {
  switch (ts) {
    case StatsInterval.LAST_5_MINS:
      return 0.08333;
    case StatsInterval.LAST_60_MINS:
      return 0.08333;
    case StatsInterval.LAST_24_HOURS:
      return 0.00139;
    default:
      return 0.08333;
  }
};
